// src/pages/Introduction.js
import React, { useEffect, useState } from "react";

const LINES = [
  "Hi. I am ReflectUS.",
  "I was created to help partners rediscover connection and understanding.",
  "I know that in the pace of everyday life, it can be hard to truly meet each other without tension or hurt.",
  "Based on what you share with me — safely and privately — I will offer a shared reflection,",
  "and then guide individual conversations and insights.",
  "I do not reveal. I listen.",
  "I look for bridges between perspectives."
];

export default function Introduction() {
  const [text, setText] = useState("");
  const [lineIndex, setLineIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (lineIndex >= LINES.length) {
      setDone(true);
      return;
    }

    const timeout = setTimeout(() => {
      setText(prev => prev + LINES[lineIndex][charIndex]);

      if (charIndex + 1 < LINES[lineIndex].length) {
        setCharIndex(charIndex + 1);
      } else {
        setText(prev => prev + "\n\n");
        setLineIndex(lineIndex + 1);
        setCharIndex(0);
      }
    }, 38);

    return () => clearTimeout(timeout);
  }, [charIndex, lineIndex]);

  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "radial-gradient(circle at 50% 45%, #123044 0%, #081822 55%, #020608 100%)",
        fontFamily: "Inter, sans-serif",
        pointerEvents: "none" // omogoči klik na header linke
      }}
    >
      <div
        style={{
          maxWidth: 640,
          width: "100%",
          padding: "40px 36px",
          background: "rgba(18,48,68,0.35)",
          border: "1px solid rgba(245,244,237,0.25)",
          borderRadius: 22,
          backdropFilter: "blur(8px)",
          boxShadow: "0 0 22px rgba(255,255,255,0.08)",
          animation: "reflectBreath 8s ease-in-out infinite",
          pointerEvents: "auto"
        }}
      >
        <pre
          style={{
            fontFamily: "Cormorant Garamond, serif",
            fontSize: 16,
            lineHeight: 1.95,
            letterSpacing: "0.045em",
            color: "#F5F4ED",
            whiteSpace: "pre-wrap",
            margin: 0
          }}
        >
          {text}
          {!done && (
            <span
              style={{
                display: "inline-block",
                width: 6,
                height: 20,
                marginLeft: 4,
                background: "#F5F4ED",
                opacity: 0.7,
                animation: "cursorBlink 1.4s ease-in-out infinite"
              }}
            />
          )}
        </pre>
      </div>

      <style>
        {`
        @keyframes cursorBlink{
          0%{opacity:0;}
          50%{opacity:0.8;}
          100%{opacity:0;}
        }
        @keyframes reflectBreath{
          0%{
            box-shadow:0 0 18px rgba(255,255,255,0.05);
          }
          50%{
            box-shadow:0 0 34px rgba(255,255,255,0.14);
          }
          100%{
            box-shadow:0 0 18px rgba(255,255,255,0.05);
          }
        }
        `}
      </style>
    </div>
  );
} 
